const KEY = 'importType';

const VALUES = {
  ENTITIES: 'entities',
  SUPPLIER_PRODUCTS: 'supplierProducts',
  PRODUCTS: 'products',
  CENTRAL_KITCHEN_PRODUCTS: 'centralKitchenProducts',
  STORE_SUPPLIER_PROFILE_MAPPING: 'storeSupplierProfileMappings',
  TRANSFERS: 'transfers',
  TRANSLATIONS: 'translations',
};

export default {
  KEY,
  VALUES,
};
